import React from "react";
import { FundItem } from "../../models/Fund";
import OverviewTabContent from "./tabContent/overview/OverviewTabContent";
import FundTeamTabContent from "./tabContent/fundTeam/FundTeamTabContent";
import TrackRecordsTabContent from "./tabContent/trackRecords/TrackRecordsTabContent";
import DataRoomTabContent from "./tabContent/dataRoom/DataRoomTabContent";

export interface IFundDetailsTabContentProps{
    fund: FundItem;
    page: number;
    createPortfolio?: boolean;
}

const FundDetailsTabContent: React.FC<IFundDetailsTabContentProps> = ({ fund, page, createPortfolio }) => {
    switch(page){
        case 0:
            return <OverviewTabContent fund={fund} createPortfolio={createPortfolio} />;
        case 1:
            return <FundTeamTabContent fund={fund} />;
        case 2:
            return <TrackRecordsTabContent fund={fund} />;
        case 3:
            return <DataRoomTabContent fund={fund} />;
        default:
            return <></>;
    }
    return <>{fund.name} page {page}</>;
}

export default FundDetailsTabContent;